
import { Injectable } from "@angular/core"
import { wsService } from "../services/ws.service";
import { SupervisorUsage } from "../interfaces/audit.interface";
import { TrsEventsService } from "./trsevents.service";
import { generateMessage } from "../utils/messages";

const packageInfo = require('../../../package.json');
// var auditDataList: any[] = [];
// var intervalStarted: boolean;
@Injectable()
export class AuditService {
    constructor(private ws: wsService, private trsService: TrsEventsService) { }

    AuditSupervisorUsage = (eventTypeId: number, agentLanId?: string, eventId?: number, chatMessage?: string) => {
        const payload: SupervisorUsage = {
            EventTypeId: eventTypeId,
            EventDateTime: new Date(),
            SupervisorVersion: packageInfo.version,
            SupervisorLanId: this.trsService.supervisorId,
            SupervisorAvayaLoginId: this.trsService.supervisorAvayaLoginId,
            AgentLanId: agentLanId,
            EventId: eventId,
            ChatMessage: chatMessage,
        };

        this.ws.sendMessage(JSON.stringify(generateMessage("DBUSAGEOPERATIONS", "SWFH", payload, this.trsService)));

        /*  let date = new Date();
         let auditData = { requestPackt, SentDateTime: date, Acknowledged: false, Sent: false }
         auditDataList.push(auditData);
         //localStorage.setItem("auditdata",JSON.stringify(auditData));
         if(!intervalStarted)
         this.SetAuditInterval(); */
    }

    AuditScreenGlance = (glanceType: 'start' | 'end' | 'decline' | 'error' | 'connected' | 'discovery', agentId: string, text: string) => {
        let eventTypeId: number = 0;
        switch (glanceType) {
            case 'start':
                eventTypeId = 20;
                break;
            case 'end':
                eventTypeId = 24;
                break;
            case 'decline':
                eventTypeId = 22;
                break;
            case 'error':
                eventTypeId = 23;
                break;
            case 'connected':
                eventTypeId = 21;
                break;
            case 'discovery':
                eventTypeId = 25;
                break;
        }

        this.AuditSupervisorUsage(eventTypeId, agentId, undefined, text);
    }
    //For FUTURE if required
    // SetAuditInterval() {
    //     intervalStarted = true;
    //     setInterval(() => {

    //         /* let auditData = JSON.parse(localStorage.getItem("auditdata") || "")            
    //         this.ws.sendMessage(JSON.stringify(auditData.requestPackt));
    //         auditData.AuditSent = true;
    //         localStorage.setItem("auditdata",JSON.stringify(auditData)); */
    //         auditDataList.forEach(element => {
    //             if (!element.Sent) {
    //                 this.ws.sendMessage(JSON.stringify(element.requestPackt));
    //                 element.Sent = true;
    //             }
    //             else if (element.Sent && !element.Acknowledged) {
    //                 let dateNow = new Date()
    //                 //let dateSent = new Date(element.SentDateTime)
    //                 if (Math.abs(dateNow.getTime() - element.SentDateTime.getTime()) / 1000 > 60) {
    //                     this.ws.sendMessage(JSON.stringify(element.requestPackt));
    //                     element.SentDateTime = new Date();
    //                 }
    //             }
    //         });
    //     }, 10000)
    // }

}          